"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _contacts_provider = _interopRequireDefault(require("./_contacts_provider"));

var _lodash = _interopRequireDefault(require("lodash"));

var ContactsApi =
/*#__PURE__*/
function (_ContactsProviderApi) {
  (0, _inherits2.default)(ContactsApi, _ContactsProviderApi);

  /**
   * Represents a Contact Api.
   * @constructor
   */
  function ContactsApi(_ref) {
    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl,
        providersAccountId = _ref.providersAccountId,
        httpGatewayUrl = _ref.httpGatewayUrl,
        sendWSMessage = _ref.sendWSMessage,
        _ref$globalCache = _ref.globalCache,
        globalCache = _ref$globalCache === void 0 ? false : _ref$globalCache;
    (0, _classCallCheck2.default)(this, ContactsApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactsApi).call(this, {
      userTokenFactory: userTokenFactory,
      sdkApiUrl: sdkApiUrl,
      providersAccountId: providersAccountId,
      httpGatewayUrl: httpGatewayUrl,
      sendWSMessage: sendWSMessage,
      globalCache: globalCache
    }));
  }
  /**
   *
   * @param {Object} param0.options options for request - {size, from, sort, scroll, scroll_id, projection}
   * @returns {Array} of contacts list
   */


  (0, _createClass2.default)(ContactsApi, [{
    key: "getContactsList",
    value: function () {
      var _getContactsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(options) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '',
                  queryParams: options,
                  errorName: 'ContactError'
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getContactsList(_x) {
        return _getContactsList.apply(this, arguments);
      }

      return getContactsList;
    }()
    /**
     *
     * @description This method fetches the list of Contacts from specific provider with MarvinDev AccountId
     * Will be deleted after Contacts API allows support of cross-account calls
     * @param {Object} param0.options options for request - {size, from, sort, scroll, scroll_id, projection}
     * @returns {Array} of contacts list
     */

  }, {
    key: "getContacts",
    value: function () {
      var _getContacts = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(options) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._callApi({
                  method: 'get',
                  path: 'contacts/list-all',
                  queryParams: options,
                  errorName: 'ContactError'
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getContacts(_x2) {
        return _getContacts.apply(this, arguments);
      }

      return getContacts;
    }()
    /**
     *
     * @param {String} param0.contactId id of contact
     * @returns {Object} contact
     */

  }, {
    key: "getContact",
    value: function () {
      var _getContact = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref2) {
        var contactId;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                contactId = _ref2.contactId;
                _context3.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '',
                  queryParams: {
                    contactId: contactId
                  },
                  errorName: 'ContactError'
                });

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getContact(_x3) {
        return _getContact.apply(this, arguments);
      }

      return getContact;
    }()
    /**
     *
     * @param {String} param0.contactId id of contact
     */

  }, {
    key: "deleteContact",
    value: function () {
      var _deleteContact = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref3) {
        var contactId;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                contactId = _ref3.contactId;
                _context4.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '',
                  queryParams: {
                    contactId: contactId
                  },
                  errorName: 'ContactError'
                });

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteContact(_x4) {
        return _deleteContact.apply(this, arguments);
      }

      return deleteContact;
    }()
    /**
     *
     * @param {Object} param0.contactData contact object with required fields contactId
     * @param {Object} param1.returning return undated contact in response
     */

  }, {
    key: "updateContact",
    value: function () {
      var _updateContact = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref4) {
        var contactData, _ref4$returning, returning;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                contactData = _ref4.contactData, _ref4$returning = _ref4.returning, returning = _ref4$returning === void 0 ? false : _ref4$returning;

                if (_lodash.default.has(contactData, 'contactId')) {
                  _context5.next = 3;
                  break;
                }

                throw new Error('ContactId is required in contact data');

              case 3:
                _context5.next = 5;
                return this._callApi({
                  method: 'put',
                  path: '',
                  queryParams: {
                    returning: returning
                  },
                  payload: contactData,
                  errorName: 'ContactError'
                });

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateContact(_x5) {
        return _updateContact.apply(this, arguments);
      }

      return updateContact;
    }()
    /**
     *
     * @param {Object} param0.contactData contact object with required fields contactId and name
     */

  }, {
    key: "createContact",
    value: function () {
      var _createContact = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref5) {
        var contactData;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                contactData = _ref5.contactData;
                _context6.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '',
                  payload: contactData,
                  errorName: 'ContactError'
                });

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createContact(_x6) {
        return _createContact.apply(this, arguments);
      }

      return createContact;
    }()
    /**
     *
     * @param {String} param0.toContact id of contact that main in merge
     * @param {Array} param0.contactData array of contact ids that merged to main contact
     */

  }, {
    key: "mergeContacts",
    value: function () {
      var _mergeContacts = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref6) {
        var toContact, fromContacts;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                toContact = _ref6.toContact, fromContacts = _ref6.fromContacts;
                _context7.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/merge',
                  payload: {
                    toContact: toContact,
                    fromContacts: fromContacts
                  },
                  errorName: 'ContactError'
                });

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function mergeContacts(_x7) {
        return _mergeContacts.apply(this, arguments);
      }

      return mergeContacts;
    }()
    /**
     *
     * @param {Object} param0.searchData fields for query and options for request
     */

  }, {
    key: "searchContacts",
    value: function () {
      var _searchContacts = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref7) {
        var searchData;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                searchData = _ref7.searchData;
                _context8.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/search',
                  payload: searchData,
                  errorName: 'ContactError'
                });

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function searchContacts(_x8) {
        return _searchContacts.apply(this, arguments);
      }

      return searchContacts;
    }()
    /**
     *
     * @param {String} param0.projection projection for get specified fields
     */

  }, {
    key: "getUsersList",
    value: function () {
      var _getUsersList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9() {
        var _ref8,
            projection,
            _args9 = arguments;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _ref8 = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {}, projection = _ref8.projection;
                _context9.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/users',
                  queryParams: {
                    projection: projection
                  },
                  errorName: 'ContactsUserError'
                });

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getUsersList() {
        return _getUsersList.apply(this, arguments);
      }

      return getUsersList;
    }()
    /**
     *
     * @param {String} param0.userId id of user
     * @param {Array} param0.contactRuleGroups rule groups for user
     */

  }, {
    key: "updateUserContactRuleGroups",
    value: function () {
      var _updateUserContactRuleGroups = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(_ref9) {
        var userId, contactRuleGroups;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                userId = _ref9.userId, contactRuleGroups = _ref9.contactRuleGroups;
                _context10.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/users',
                  queryParams: {
                    userId: userId
                  },
                  payload: {
                    contactRuleGroups: contactRuleGroups
                  },
                  errorName: 'UserContactRuleGroupsError'
                });

              case 3:
                return _context10.abrupt("return", _context10.sent);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function updateUserContactRuleGroups(_x9) {
        return _updateUserContactRuleGroups.apply(this, arguments);
      }

      return updateUserContactRuleGroups;
    }()
    /**
     * @param {String} param0.userId userId
     * @param {Array} param1.addContactRuleGroups array of groups ids add to user groups
     * @param {Array} param2.removeContactRuleGroups array of groups ids remove to user groups
     * @returns {Object} user groups
     */

  }, {
    key: "patchUserContactRuleGroups",
    value: function () {
      var _patchUserContactRuleGroups = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref10) {
        var userId, addContactRuleGroups, removeContactRuleGroups;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                userId = _ref10.userId, addContactRuleGroups = _ref10.addContactRuleGroups, removeContactRuleGroups = _ref10.removeContactRuleGroups;
                _context11.next = 3;
                return this._callApi({
                  method: 'patch',
                  path: '/users',
                  queryParams: {
                    userId: userId
                  },
                  payload: {
                    addContactRuleGroups: addContactRuleGroups,
                    removeContactRuleGroups: removeContactRuleGroups
                  },
                  errorName: 'UserContactRuleGroupsError'
                });

              case 3:
                return _context11.abrupt("return", _context11.sent);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function patchUserContactRuleGroups(_x10) {
        return _patchUserContactRuleGroups.apply(this, arguments);
      }

      return patchUserContactRuleGroups;
    }()
    /**
     *
     * @returns {Array} rule groups list
     */

  }, {
    key: "getContactRuleGroupsList",
    value: function () {
      var _getContactRuleGroupsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12() {
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/rule-groups',
                  errorName: 'ContactRuleGroupsError'
                });

              case 2:
                return _context12.abrupt("return", _context12.sent);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getContactRuleGroupsList() {
        return _getContactRuleGroupsList.apply(this, arguments);
      }

      return getContactRuleGroupsList;
    }()
    /**
     * @param {String} param0.groupId id of rule group
     * @returns {Object} rule group
     */

  }, {
    key: "getContactRuleGroup",
    value: function () {
      var _getContactRuleGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(_ref11) {
        var groupId;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                groupId = _ref11.groupId;
                _context13.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/rule-groups',
                  queryParams: {
                    groupId: groupId
                  },
                  errorName: 'ContactRuleGroupsError'
                });

              case 3:
                return _context13.abrupt("return", _context13.sent);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getContactRuleGroup(_x11) {
        return _getContactRuleGroup.apply(this, arguments);
      }

      return getContactRuleGroup;
    }()
    /**
     * @param {String} param0.name name of rule group
     * @param {Array} param1.rules user permissions rules
     * @returns {Object} add stats
     */

  }, {
    key: "addContactRuleGroup",
    value: function () {
      var _addContactRuleGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(_ref12) {
        var name, rules;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                name = _ref12.name, rules = _ref12.rules;
                _context14.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/rule-groups',
                  payload: {
                    name: name,
                    rules: rules
                  },
                  errorName: 'ContactRuleGroupsError'
                });

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function addContactRuleGroup(_x12) {
        return _addContactRuleGroup.apply(this, arguments);
      }

      return addContactRuleGroup;
    }()
    /**
     * @param {String} param0.groupId id of rule group
     * @param {String} param1.name name of rule group
     * @param {Array} param2.rules user permissions rules
     * @returns {Object} update stats
     */

  }, {
    key: "updateContactRuleGroup",
    value: function () {
      var _updateContactRuleGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(_ref13) {
        var groupId, name, rules;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                groupId = _ref13.groupId, name = _ref13.name, rules = _ref13.rules;
                _context15.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/rule-groups',
                  payload: {
                    groupId: groupId,
                    name: name,
                    rules: rules
                  },
                  errorName: 'ContactRuleGroupsError'
                });

              case 3:
                return _context15.abrupt("return", _context15.sent);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function updateContactRuleGroup(_x13) {
        return _updateContactRuleGroup.apply(this, arguments);
      }

      return updateContactRuleGroup;
    }()
    /**
     * @param {String} param0.groupId id of rule group
     * @returns {Object} delete stats
     */

  }, {
    key: "deleteContactRuleGroup",
    value: function () {
      var _deleteContactRuleGroup = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(_ref14) {
        var groupId;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                groupId = _ref14.groupId;
                _context16.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '/rule-groups',
                  queryParams: {
                    groupId: groupId
                  },
                  errorName: 'ContactRuleGroupsError'
                });

              case 3:
                return _context16.abrupt("return", _context16.sent);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function deleteContactRuleGroup(_x14) {
        return _deleteContactRuleGroup.apply(this, arguments);
      }

      return deleteContactRuleGroup;
    }()
    /**
     * @param {String} param0.bookName name of contacts book
     * @param {String} param1.index index of contacts table
     * @param {String} param2.bookAccountId accountId which contain contacts table
     * @returns {Object} number of records
     */

  }, {
    key: "getContactRecordsCount",
    value: function () {
      var _getContactRecordsCount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(_ref15) {
        var bookName, index, bookAccountId;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                bookName = _ref15.bookName, index = _ref15.index, bookAccountId = _ref15.bookAccountId;
                _context17.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/count',
                  queryParams: {
                    bookName: bookName,
                    index: index,
                    bookAccountId: bookAccountId
                  },
                  errorName: 'ContactRecordCountError'
                });

              case 3:
                return _context17.abrupt("return", _context17.sent);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getContactRecordsCount(_x15) {
        return _getContactRecordsCount.apply(this, arguments);
      }

      return getContactRecordsCount;
    }()
    /**
     *
     * @returns {Object} {creckContactsInstalled: true or false}
     */

  }, {
    key: "checkContactsInstalled",
    value: function () {
      var _checkContactsInstalled = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18() {
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/check',
                  errorName: 'ContactError'
                });

              case 2:
                return _context18.abrupt("return", _context18.sent);

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function checkContactsInstalled() {
        return _checkContactsInstalled.apply(this, arguments);
      }

      return checkContactsInstalled;
    }()
    /**
     *
     * @returns {Object} last migration data
     */

  }, {
    key: "getLastMigrationVersion",
    value: function () {
      var _getLastMigrationVersion = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19() {
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/last-migration-version',
                  errorName: 'ContactError'
                });

              case 2:
                return _context19.abrupt("return", _context19.sent);

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getLastMigrationVersion() {
        return _getLastMigrationVersion.apply(this, arguments);
      }

      return getLastMigrationVersion;
    }()
    /**
     *
     * @returns {Object} deployed contacts versions
     */

  }, {
    key: "getDeployedContactsVersion",
    value: function () {
      var _getDeployedContactsVersion = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee20() {
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/deployed-versions',
                  errorName: 'ContactError'
                });

              case 2:
                return _context20.abrupt("return", _context20.sent);

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getDeployedContactsVersion() {
        return _getDeployedContactsVersion.apply(this, arguments);
      }

      return getDeployedContactsVersion;
    }()
  }]);
  return ContactsApi;
}(_contacts_provider.default);

var _default = ContactsApi;
exports.default = _default;